import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    TextField,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import { REACT_APP_BACKEND_URL } from "../../../Utils/Language/urlBase";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";
import { useParams } from "react-router";

const StockLocationItems = () => {
    const [stockItems, setStockItems] = useState([]);
    const [searchKey, setSearchKey] = useState("");
    const [loading, setLoading] = useState(false);
    const authHeader = useAuthHeader();
    const params = useParams();
    const { stockLocationId } = params;
    console.log({ params });

    // Fetch Stock Location Items

    // Trigger fetch on component mount and when searchKey changes
    useEffect(() => {
        const fetchStockItems = async () => {
            setLoading(true);
            try {
                const response = await fetch(
                    `${REACT_APP_BACKEND_URL}/stock/stockLocation/getStockLocationItems/${stockLocationId}?searchKey=${searchKey}`,
                    {
                        headers: { Authorization: authHeader },
                    }
                );
                if (response.ok) {
                    const { items } = await response.json();
                    setStockItems(items);
                } else {
                    toast.error("Failed to fetch stock location items");
                }
            } catch (error) {
                toast.error("An error occurred while fetching items");
            } finally {
                setLoading(false);
            }
        };
        fetchStockItems();
    }, [authHeader, searchKey, stockLocationId]);

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
                Stock Location Items
            </Typography>

            {/* Search Field */}
            <TextField
                label="Search Items"
                variant="outlined"
                fullWidth
                margin="normal"
                value={searchKey}
                onChange={(e) => setSearchKey(e.target.value)}
                placeholder="Search by name, quantity, or expiry"
            />

            {/* Loading Indicator */}
            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
                    <CircularProgress />
                </Box>
            ) : (
                // Items Table
                <TableContainer sx={{ mt: 2 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Quantity</TableCell>
                                <TableCell>Expiry Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {stockItems.length > 0 ? (
                                stockItems.map((item) => (
                                    <TableRow key={item.id}>
                                        <TableCell>{item.item.name}</TableCell>
                                        <TableCell>
                                            {item.quantityRemaining}
                                        </TableCell>
                                        <TableCell>
                                            {new Date(
                                                item.expiryDate
                                            ).toLocaleString()}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={3} align="center">
                                        No items found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

export default StockLocationItems;
